import React from "react";
import { Receipt, ArrowRight } from "lucide-react";

const TopSpending = ({ categorizedExpenses }) => {
  // Normalize category names to lowercase to handle case insensitivity
  const normalizedCategories = Object.entries(categorizedExpenses)
    .map(([category, amount]) => ({ category: category.toLowerCase(), amount })) // Convert category name to lowercase
    .reduce((acc, { category, amount }) => {
      // Aggregate amounts for the same category
      if (acc[category]) {
        acc[category] += amount;
      } else {
        acc[category] = amount;
      }
      return acc;
    }, {});

  // Convert the object back to an array and sort by amount
  const sortedCategories = Object.entries(normalizedCategories)
    .map(([category, amount]) => ({ category, amount }))
    .sort((a, b) => b.amount - a.amount); // Sort by highest spending

  return (
    <div>
      <h2 className="fs-5 fw-semibold mb-3">Top Spending</h2>
      {sortedCategories.map((item, index) => (
        <div className="d-flex align-items-center justify-content-between py-2 mb-1 px-2 border" key={index}>
          <div className="d-flex align-items-center gap-3">
            <div className="p-2 bg-success-subtle rounded-circle">
              <Receipt className="text-success" style={{ width: "20px", height: "20px" }} />
            </div>
            <p className="mb-0 fw-medium">{item.category}</p>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span className="fw-semibold">₹{item.amount.toFixed(2)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopSpending;
